import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-lombok',
  standalone: true,
  imports: [],
  templateUrl: './lombok.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './lombok.component.scss'
})
export class LombokComponent {

}
